export default __webpack_public_path__ + "static/media/ColonialCurrencySlide1.94d71726.jpg";